import { FontIconName, NoResults } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";

export type NoEmailsResultProps = {
	searchTerm: string;
};

export const NoEmailsResult = (props: NoEmailsResultProps): ReactElement => {
	const { searchTerm } = props;

	const icon: FontIconName = searchTerm ? "magnifying-glass" : "envelope";
	const title: string = searchTerm ? localize("_NoSearchResults") : localize("_NoEmailsToShow");
	const message: string = searchTerm
		? localize("_PleaseTrySearchingWithAnotherTerm")
		: localize("_ThereAreCurrentlyNoItemsToShowHere");

	return (
		<NoResults
			trackingId="no-emails-result"
			icon={icon} title={title}
			message={message}
			height="fill"
		/>
	);
};

NoEmailsResult.displayName = "NoEmailResult";
